import { createSlice } from '@reduxjs/toolkit';
import { createOrder } from './ordersSlice';

// Load cart from localStorage
const loadCartFromStorage = () => {
  try {
    const cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    return [];
  }
};

// Save cart to localStorage
const saveCartToStorage = (items) => {
  localStorage.setItem('cart', JSON.stringify(items));
};

// Calculate cart total
const calculateTotal = (items) => {
  return items.reduce((total, item) => {
    const price = parseFloat(item.discount_price || item.price);
    return total + price * item.quantity;
  }, 0);
};

// Initial state
const initialState = {
  items: loadCartFromStorage(),
  total: calculateTotal(loadCartFromStorage()),
};

// Cart slice
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;
      const existingItem = state.items.find((item) => item.id === product.id);

      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.items.push({ ...product, quantity: 1 });
      }

      state.total = calculateTotal(state.items);
      saveCartToStorage(state.items);
    },
    removeFromCart: (state, action) => {
      const productId = action.payload;
      state.items = state.items.filter((item) => item.id !== productId);
      state.total = calculateTotal(state.items);
      saveCartToStorage(state.items);
    },
    updateQuantity: (state, action) => {
      const { productId, quantity } = action.payload;
      const item = state.items.find((item) => item.id === productId);

      if (item && quantity > 0) {
        item.quantity = quantity;
        state.total = calculateTotal(state.items);
        saveCartToStorage(state.items);
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.total = 0;
      localStorage.removeItem('cart');
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createOrder.fulfilled, (state) => {
      state.items = [];
      state.total = 0;
      localStorage.removeItem('cart');
    });
  },
});

// Selectors
export const selectCartTotal = (state) => state.cart.total;
export const selectCartItemsCount = (state) =>
  state.cart.items.reduce((count, item) => count + item.quantity, 0);

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
